import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { useEffect as p, useMemo as d } from "react";
import { useTranslation as f } from "react-i18next";
import { useCurrentStage as h } from "@perxis-auto/trade-in-sdk";
import { ErrorStatusCode as u } from "@perxis-auto/trade-in-sdk/types";
import { Button as g } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row as n, Col as t } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Icon as S } from "@perxis-auto/ui-kit/lib/components/Icon";
import { Typography as a } from "@perxis-auto/ui-kit/lib/components/Typography";
import { APP as x } from "../../../shared/config/app.js";
import { useAppContext as E } from "../../../shared/lib/app/context/appContext.js";
function j() {
  const { onReset: c, onFailure: o } = E(), { error: i } = h(), { t: e } = f(x.name);
  p(() => {
    o == null || o();
  }, []);
  const { title: l, description: m } = d(() => i && i.statusCode === u.FORMS_GET_ESTIMATE_NOT_FOUND ? {
    title: e("errorStage.noEstimate.title"),
    description: e("errorStage.noEstimate.description")
  } : {
    title: e("errorStage.title"),
    description: e("errorStage.description")
  }, [i, e]);
  return /* @__PURE__ */ s(n, { gutter: [0, "vertical-yellow"], children: [
    /* @__PURE__ */ r(t, { span: 24, children: /* @__PURE__ */ s(n, { gutter: [0, "vertical-sky"], className: "pa-trade-in-card", children: [
      /* @__PURE__ */ r(t, { span: 24, children: /* @__PURE__ */ r(a.Title, { className: "pa-trade-in-card__title", color: "darkest", level: "h3", children: l }) }),
      /* @__PURE__ */ r(t, { span: 24, children: /* @__PURE__ */ r(a.Text, { className: "pa-trade-in-card__description", color: "dark", level: "main", children: m }) })
    ] }) }),
    /* @__PURE__ */ r(t, { span: 24, children: /* @__PURE__ */ r(n, { gutter: [16, "vertical-sky"], children: /* @__PURE__ */ r(t, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: /* @__PURE__ */ r(
      g,
      {
        type: "ghost",
        icon: /* @__PURE__ */ r(S, { name: "refresh", sticker: "trade-in-instock-refresh-icon" }),
        onClick: c,
        children: e("errorStage.startAgain")
      }
    ) }) }) })
  ] });
}
export {
  j as ErrorStage
};
